// Shared polling for Anki deck exports built server-side (see AnkiDecksController).
// The component must expose the `apiUrl` getter. `done(success)` is always called.
const POLL_INTERVAL_MS = 3000;
const POLL_TIMEOUT_MS = 10 * 60 * 1000;

export default {
  methods: {
    pollAnkiExport(token, filename, done) {
      const startedAt = Date.now();

      const tick = () => {
        this.$http.get(`${this.apiUrl}/anki_exports/${token}/status`).then(res => {
          if (res.body.status === "ready") {
            window.location.href = `${this.apiUrl}/anki_exports/${token}?filename=${encodeURIComponent(filename)}`;
            this.$toast.success("Your Anki deck is downloading!", { duration: 6000 });
            done(true);
          } else if (res.body.status === "error") {
            this.$toast.error("The export failed. Please try again or contact us.", { duration: 8000 });
            done(false);
          } else if (Date.now() - startedAt > POLL_TIMEOUT_MS) {
            this.$toast.error("The export is taking longer than expected. Please try again later.", { duration: 8000 });
            done(false);
          } else {
            setTimeout(tick, POLL_INTERVAL_MS);
          }
        }).catch(() => {
          this.$toast.error("The export failed. Please try again.", { duration: 8000 });
          done(false);
        });
      };

      tick();
    }
  }
};
